import React, { Suspense, useEffect, useState } from "react";
import { useRoutes, useLocation } from "react-router-dom";
import { Modal } from 'antd-mobile';
import {rewirteLog} from './utils/turn'

// 首页
const Index = React.lazy(() => import('./pages/index/index'));
// 个人中心
const Personal = React.lazy(() => import('./pages/personal'));
// // 商铺
const Shop = React.lazy(() => import('./pages/shop'));
// // 店铺设置
const Setshop = React.lazy(() => import('./pages/setShop'))
// // 订单播报设置
const OrderBroadcast = React.lazy(() => import('./pages/setShop/orderBroadcast'))
// //  订单打印模式
const OrderPrintMod = React.lazy(() => import('./pages/setShop/orderPintMod'))
// // 打印机管理
const Preview = React.lazy(() => import('./pages/preview'))
// // 顾客联
const CustomerLink = React.lazy(() => import('./pages/customerLink'))
// // 订单管理
const Management = React.lazy(() => import('./pages/orderManagement'))
// // 打印机列表
const OrderList = React.lazy(() => import('./pages/orderList'))
// // 输出打印
const PrintInput = React.lazy(() => import('./pages/orderList/printInput'))
// // 控制台
const Console = React.lazy(() => import('./pages/orderList/console'))
// // 修改终端名称
const SetConsole = React.lazy(() => import('./pages/orderList/setConsoleName'))
// // 卡餐上报
const CardMeal = React.lazy(() => import('./pages/cardMeal'))
// // 上报详情
const DetailsReport = React.lazy(() => import('./pages/cardMeal/detailsReport'))
// // 修改密码
// ...
const ChangePwd = React.lazy(() => import('./pages/personal/changePwd'))
// // 忘记密码
const ForgotPwd = React.lazy(() => import('./pages/personal/forgotPwd'))
// // 关于我们 
const AboutUs = React.lazy(() => import('./pages/personal/aboutUs'))
// // 手动添加
const AddPrint = React.lazy(() => import('./pages/addPrint'))
//  账号密码输入
const Pwdinput = React.lazy(() => import('./pages/user/pwdCode'));
// 手机号登录
const Phoneinput = React.lazy(() => import('./pages/user/phoneCode'));
// 终端打印列表
const TerminalList = React.lazy(() => import('./pages/orderList/terminalList'));
// 今日未打印
const TodayUniprint = React.lazy(() => import('./pages/todayunprinted'));
// 浏览
const Glance = React.lazy(() => import('./pages/preview/Glance'));
// 微盟店铺设置
const WeimengShop = React.lazy(() => import('./pages/wm-setPrint'));
// 店铺授权
const Accredit = React.lazy(() => import('./pages/accredit'))
// 新用户设置密码
const SetPwd = React.lazy(() => import('./pages/user/setPwd'))
// // 修改手机号
const SetMobile = React.lazy(() => import('./pages/personal/setmobile'))
//  用户协议
const Deal = React.lazy(() => import('./pages/personal/deal'))
//订阅收费
const Pay = React.lazy(() => import('./pages/pay/index'));
// orderDetail
const OrderDetails = React.lazy(() => import('./pages/orderManagement/order_details'))
// 收银扫码
const Cash = React.lazy(() => import('./pages/cash/index'))

// 第三方跳转登录
const InLogin = React.lazy(() => import('./pages/user/inlogin'))
// 点餐系统描述页
const BuyAlert = React.lazy(() => import('./pages/buyAlert'))
// k8收银
const K8Cash = React.lazy(() => import('./pages/cash/K8'))
// 验券设置
const VaildationCertificate = React.lazy(() => import('./pages/validationCertificate/index'))
// 验券历史
const AnnulValidation = React.lazy(() => import('./pages/annulValidation/index'))

// 设置关键词
const Setkey = React.lazy(() => import('./pages/cash/K8/setkey'))

// 扫码收银
const ScanCash = React.lazy(() => import('./pages/cash/scan'))
// 扫码收银 金额输入
const ScanPay = React.lazy(() => import('./pages/cash/scan/scanPay'))

// 码牌收银
const CodePlate = React.lazy(() => import('./pages/cash/codePlate'))

// 码牌收银播报
const Broadcast = React.lazy(() => import('./pages/cash/codePlate/broadcast'))

// 扫码之后绑定页
const BindCodePlate = React.lazy(() => import('./pages/cash/codePlate/bindCodePlate'))

// 扫码之后支付
const PlatePay = React.lazy(() => import('./pages/platepay'))

// 步骤
const Step = React.lazy(() => import('./pages/step'))

// 下载码牌
const DownImg=React.lazy(()=>import('./pages/cash/codePlate/downImg/index'))

// 免费试
const Mfs=React.lazy(()=>import('./pages/mfs'))

// 404
const NotFound = React.lazy(() => import('./pages/notFound'));

// 团购验券设置
const TgVouchers=React.lazy(()=>import('./pages/setTgVouchers'))

// 出餐宝
const Ccb=React.lazy(()=>import('./pages/ccb'))

// 嘀嘀嘀语音信息页
const DDDOverview=React.lazy(()=>import('./pages/DDD-overview'))

// 试听语音
const AudioPreview=React.lazy(()=>import('./pages/audio-preview'))

// 开通语音
const VoiceActivations=React.lazy(()=>import('./pages/VoiceActivations'))

// 扫码开通语音
const PayAudio=React.lazy(()=>import('./pages/pay_audio'))

// 快团团订单管理
const KttOrder=React.lazy(()=>import('./pages/KttOrder'))

// 打印机设置
const DevicePrintSet=React.lazy(()=>import('./pages/DevicePrintSet'))

// 打印机设置
const WdPrintSet=React.lazy(()=>import('./pages/DevicePrintSet/Wd'))

// 打印机设置选择商品
const SelectProduct=React.lazy(()=>import('./pages/DevicePrintSet/selectProduct'))

// 微盟设置
const WMDevicePrintSet=React.lazy(()=>import('./pages/WMDevicePrintSet'))

// 微盟设置选择商品
const WmSelectProduct=React.lazy(()=>import('./pages/WMDevicePrintSet/selectProduct'))

// 京东到家商家信息
const JDDJ=React.lazy(()=>import('./pages/shop/components/JDDJ'))

// 京东到家商家信息
const TMSG=React.lazy(()=>import('./pages/shop/components/TMSG'))

// 团购验券历史
const TgAnnulValidation = React.lazy(() => import('./pages/TgValidationCertificate'))

// 选择小票打印机
const SelectPrintTicket=React.lazy(()=>import('./pages/selectPrintTicket'))

// 标签规格设置
const LableSet=React.lazy(()=>import('./pages/lableset'))

// 预订单
const PresetOrder=React.lazy(()=>import('./pages/presetOrder'))

// 预订单时间设置
const PresetTimeSet=React.lazy(()=>import('./pages/presetOrder/set'))

// 自动配送
const SelfDelivery=React.lazy(()=>import('./pages/selfDelivery'))

// 自配送淘宝闪购打印设置
const SetElmPrint=React.lazy(()=>import('./pages/selfDelivery/setElmPrint'))

// 撤销验券
const CancelRecord=React.lazy(()=>import('./pages/cancelRecord'))

// 出餐宝网络设置
const NetworkSet=React.lazy(()=>import('./pages/orderList/networkSet'))

// 流量卡预告
const Trailer=React.lazy(()=>import('./pages/trailer'))

// 打印机设置后厨联商品排序
const DevSetProduct=React.lazy(()=>import('./pages/DevicePrintSet/setProduct'))

// 打印机设置后厨联分类排序
const DevSetCategory=React.lazy(()=>import('./pages/DevicePrintSet/setCategory'))

// 异常通知部分
// 异常首页
const Abnormal=React.lazy(()=>import('./pages/abnormal/index'))

// 设备管理
const DeviceManage=React.lazy(()=>import('./pages/abnormal/deviceManage'))

// 添加设备
const AddDevice=React.lazy(()=>import('./pages/abnormal/deviceManage/addDevice'))

// 店铺管理
const ShopManage=React.lazy(()=>import('./pages/abnormal/shopManage'))

// 店铺列表
const ShopList=React.lazy(()=>import('./pages/abnormal/shopManage/shopList'))

// 添加店铺
const AddShop=React.lazy(()=>import('./pages/abnormal/shopManage/addShop'))

// 通知设置
const Notice=React.lazy(()=>import('./pages/abnormal/notice'))

// 通知店铺列表
const ShopNotice=React.lazy(()=>import('./pages/abnormal/notice/shopNotice'))

// 通知设备列表
const DeviceNotice=React.lazy(()=>import('./pages/abnormal/notice/deviceNotice'))

// ===== 新版异常通知模块（abnormalNotice，前缀 /n） =====
// 异常首页
const NAbnormal=React.lazy(()=>import('./pages/abnormalNotice/index'))
// 设备管理
const NDeviceManage=React.lazy(()=>import('./pages/abnormalNotice/deviceManage'))
// 添加设备
const NAddDevice=React.lazy(()=>import('./pages/abnormalNotice/deviceManage/addDevice'))
// 店铺管理
const NShopManage=React.lazy(()=>import('./pages/abnormalNotice/shopManage'))
// 店铺列表
const NShopList=React.lazy(()=>import('./pages/abnormalNotice/shopManage/shopList'))
// 添加店铺
const NAddShop=React.lazy(()=>import('./pages/abnormalNotice/shopManage/addShop'))
// 通知设置
const NNotice=React.lazy(()=>import('./pages/abnormalNotice/notice'))
// 通知列表
const NNoticeList=React.lazy(()=>import('./pages/abnormalNotice/notice/noticeList'))
// 开放应用通知
const NAppNotice=React.lazy(()=>import('./pages/abnormalNotice/appNotice'))
// yly添加设备列表
const NYlyDevice=React.lazy(()=>import('./pages/abnormalNotice/deviceManage/ylyDevice'))
// 易联云账户添加店铺
const NYlyAddShop=React.lazy(()=>import('./pages/abnormalNotice/shopManage/ylyAddShop'))
// 订单异常
const NOrderException=React.lazy(()=>import('./pages/abnormalNotice/notice/orderException'))
// 用户信息
const NUInfo=React.lazy(()=>import('./pages/abnormalNotice/uInfo'))

// 授权登陆
const Consent=React.lazy(()=>import('./pages/user/consent/index'))

// 服务订单
const ServiceOrder=React.lazy(()=>import('./pages/personal/serviceOrder'))

// 服务订单详情
const ServiceOrderDetail=React.lazy(()=>import('./pages/personal/serviceOrder/serviceOrderDetail'))


// 写个注释

const App = () => {
  let routes = useRoutes([
    { path: '/', element: <Index /> },
    { path: '/personal', element: <Personal /> },
    { path: '/shop/:appid', element: <Shop /> },
    { path: '/setShop/:appid/:shopid', element: <Setshop /> },
    { path: '/orderBroadcast/:appid/:shopid/:type', element: <OrderBroadcast /> },
    { path: '/orderPrintMod/:appid/:shopid', element: <OrderPrintMod /> },
    { path: '/preview/:appid/:shopid', element: <Preview /> },
    { path: '/customerLink/:appid/:shopid/:temID/:code/:status', element: <CustomerLink /> },
    { path: '/management', element: <Management /> },
    { path: '/deviceList', element: <OrderList /> },
    { path: '/printInput/:id', element: <PrintInput /> },
    { path: '/console/:id', element: <Console /> },
    { path: '/setConsole/:id', element: <SetConsole /> },
    { path: '/cardMeal', element: <CardMeal /> },
    { path: '/detailsReport/:shopid/:shopname', element: <DetailsReport /> },
    { path: '/changePassword', element: <ChangePwd /> },
    { path: '/forgotPwd', element: <ForgotPwd /> },
    { path: '/setMobile', element: <SetMobile /> },
    { path: '/aboutUs/:mobile/:code', element: <AboutUs /> },
    { path: '/addprint', element: <AddPrint /> },
    { path: '/pwdinput', element: <Pwdinput></Pwdinput> },
    { path: '/phoneinput', element: <Phoneinput></Phoneinput> },
    { path: '/terminalList/:id', element: <TerminalList></TerminalList> },
    { path: '/todayUniprint', element: <TodayUniprint></TodayUniprint> },
    { path: '/glance/:appid/:shopid/:code/:temID', element: <Glance></Glance> },
    { path: '/weimengShop/:shopid/:code', element: <WeimengShop></WeimengShop> },
    { path: '/accredit', element: <Accredit></Accredit> },
    { path: '/setpwd', element: <SetPwd></SetPwd> }, 
    { path: '/pay/:appid/:shopid', element: <Pay></Pay> },
    { path: '/deal', element: <Deal></Deal> },
    { path: '/inlogin', element: <InLogin></InLogin> },
    { path: '/orderDetails/:id/:app_type', element: <OrderDetails></OrderDetails> },
    { path: '/buyAlert', element: <BuyAlert></BuyAlert> },
    { path: '/cash', element: <Cash></Cash> },
    { path: '/K8Cash', element: <K8Cash></K8Cash> },
    { path: '/VaildationCertificate/:appid/:shopid', element: <VaildationCertificate></VaildationCertificate> },
    { path: '/annulValidation/:appid/:shopid/:type', element: <AnnulValidation></AnnulValidation> },
    { path: '/K8Cash/setkey/:id/:mold', element: <Setkey></Setkey> },
    { path: '/scanCash', element: <ScanCash></ScanCash> },
    { path: '/scanPay/:id', element: <ScanPay></ScanPay> },
    { path: '/codePlate', element: <CodePlate></CodePlate> },
    { path: '/broadcast/:code', element: <Broadcast></Broadcast> },
    { path: '/bindCodePlate', element: <BindCodePlate></BindCodePlate> },
    { path: '/platePay/:code', element: <PlatePay></PlatePay> },
    { path: '/step/:appid', element: <Step></Step> },
    { path: '/downImg', element: <DownImg></DownImg> },
    { path: '/tgVouchers/:appid/:shopid/:code', element: <TgVouchers></TgVouchers> },
    { path: '/mfs', element: <Mfs></Mfs> },
    { path: '/DDD-overview/:id', element: <DDDOverview></DDDOverview> },
    { path: '/audio-preview', element: <AudioPreview></AudioPreview> },
    { path: '/voiceActivations', element: <VoiceActivations></VoiceActivations> },
    { path: '/pay_audio/:code/:id', element: <PayAudio></PayAudio> },
    { path: '/ktt_order/:shop_id', element: <KttOrder></KttOrder> },
    { path: '/devicePrintSet/:appid/:shopid/:code', element: <DevicePrintSet></DevicePrintSet> },
    { path: '/wdPrintSet/:appid/:shopid/:code', element: <WdPrintSet></WdPrintSet> },
    { path: '/wmdevicePrintSet/:appid/:shopid/:code', element: <WMDevicePrintSet></WMDevicePrintSet> },
    { path: '/selectProduct/:appid/:shopid/:code/:vid?', element: <SelectProduct></SelectProduct> },
    { path: '/wmselectProduct/:storeId/:shopid/:code', element: <WmSelectProduct></WmSelectProduct> },
    { path: '/jdauth/:appid', element: <JDDJ></JDDJ> },
     { path: '/tmsgauth/:appid', element: <TMSG></TMSG> },
    { path: '/TgAnnulValidation/:appid/:shopid/:code', element: <TgAnnulValidation></TgAnnulValidation> },
    { path: '/selectPrintTicket/:appid/:shopid/:code', element: <SelectPrintTicket></SelectPrintTicket> },
    { path: '/lableSet/:appid/:shopid/:code', element: <LableSet></LableSet> },
    { path: '/presetOrder', element: <PresetOrder></PresetOrder> },
    { path: '/PresetTimeSet/:appid/:shopid', element: <PresetTimeSet></PresetTimeSet> },
    { path: '/selfDelivery', element: <SelfDelivery></SelfDelivery> },
    { path: '/selfDelivery/setElmPrint', element: <SetElmPrint></SetElmPrint> },
    { path: '/ccb/:appid/:shopid/:code', element: <Ccb></Ccb> },
    { path: '/CancelRecord/:shopid', element: <CancelRecord></CancelRecord> },
    { path: '/networkSet', element: <NetworkSet></NetworkSet> },
    { path: '/setProduct/:appid/:shopid/:code', element: <DevSetProduct></DevSetProduct> },
    { path: '/setCategory/:appid/:shopid/:code', element: <DevSetCategory></DevSetCategory> },
    { path: '/trailer', element: <Trailer></Trailer> },
    { path: '/abnormal', element: <Abnormal></Abnormal> },
    { path: '/deviceManage', element: <DeviceManage></DeviceManage> },
    { path: '/addDevice', element: <AddDevice></AddDevice> },
    { path: '/sManage', element: <ShopManage></ShopManage> },
    { path: '/sList', element: <ShopList></ShopList> },
    { path: '/addS', element: <AddShop></AddShop> },
    { path: '/notice/:type', element: <Notice></Notice> },
    { path: '/sNotice', element: <ShopNotice></ShopNotice> },
    { path: '/deviceNotice', element: <DeviceNotice></DeviceNotice> },
    // 新版异常通知模块（/n 前缀）
    { path: '/n', element: <NAbnormal></NAbnormal> },
    { path: '/n/deviceManage', element: <NDeviceManage></NDeviceManage> },
    { path: '/n/addDevice', element: <NAddDevice></NAddDevice> },
    { path: '/n/sManage', element: <NShopManage></NShopManage> },
    { path: '/n/sList/:type', element: <NShopList></NShopList> },
    { path: '/n/adds/:type', element: <NAddShop></NAddShop> },
    { path: '/n/notice/:type', element: <NNotice></NNotice> },
    { path: '/n/noticeList/:type/:se/:code?', element: <NNoticeList></NNoticeList> },
    { path: '/n/appNotice', element: <NAppNotice></NAppNotice> },
    { path: '/n/ylyDevice/:type/:ipage', element: <NYlyDevice></NYlyDevice> },
    { path: '/n/ylyAddS/:type/:ipage', element: <NYlyAddShop></NYlyAddShop> },
    { path: '/n/orderException/:type/:se', element: <NOrderException></NOrderException> },
    { path: '/n/uInfo/:rt/:type', element: <NUInfo></NUInfo> },
    { path: '/login/scan', element: <Consent></Consent> },
    { path: '/serviceOrder', element: <ServiceOrder></ServiceOrder> },
    { path: '/serviceOrderDetail/:order_id', element: <ServiceOrderDetail></ServiceOrderDetail> },
    { path: '*', element: <NotFound></NotFound> }
  ]) 

  return routes
}
export default () => {

  const location = useLocation();

  const pathname = location.pathname;
  rewirteLog();

  useEffect(function () {
    Modal.clear()
  }, [pathname])



  return (
    // <PullToRefresh
    //   onRefresh={async () => {
    //     await sleep(1000)
    //     setData([...getNextData(), ...data])
    //   }}
    // >
    <Suspense>
      <App />
    </Suspense>
    // </PullToRefresh>
  )
}